import { Outlet } from 'react-router-dom';
import Sidebar from '../components/navigation/UserSidebar';
import Header from '../components/navigation/Header';

const UserLayout = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default UserLayout; 